export default __webpack_public_path__ + "static/media/Facilities-CACS-19.2dadf8c2.jpg";